export const AUDIT_CHANGE_FIELD_NAMES = {
  DTC_ID: 'DtcId',
  DTC_PARENT_ID: 'DtcParentId',
  DTC_CHILD_ID: 'DtcChildId',
  ERROR_MESSAGE_ID: 'ErrorMessageId',
  ERROR_MESSAGE_PARENT_ID: 'ErrorMessageParentId',
  ERROR_MESSAGE_CHILD_ID: 'ErrorMessageChildId',
  SW_PART_NUMBER_PARENT_ID: 'SwPartNumberParentId',
  SW_PART_NUMBER_CHILD_ID: 'SwPartNumberChildId',
};
